module.exports = __webpack_public_path__ + "media/images/img-hobby-4-363f954d.jpg";